import { styled } from "@mui/material/styles";

import { GL_BRIGHT_COLOR, NEUTRAL_LIGHTER_COLOR, NEUTRAL_MID_COLOR } from "../constants";

interface BadgeProps {
  disabled?: boolean;
}

export const Badge = styled("span")<BadgeProps>(({ disabled }) => ({
  marginLeft: "8px",
  padding: "2px 6px",
  borderRadius: "100px",
  fontSize: "0.75rem",
  fontWeight: 500,
  backgroundColor: disabled ? NEUTRAL_LIGHTER_COLOR : GL_BRIGHT_COLOR,
  color: disabled ? NEUTRAL_MID_COLOR : "#FFFFFF",
}));
